module.exports = __webpack_public_path__ + "static/media/all-set-mobile.7917624c.svg";